import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatterService {
  private readonly delimiter: RegExp = new RegExp('[ _-]');

  private static typeCase(word: string): string {
    const upper = word.slice(0, 1).toUpperCase();
    const lower = word.slice(1).toLowerCase();
    return upper + lower;
  }

  public userFriendlyString(string: string): string {
    if (string !== undefined) {
      return string.split(this.delimiter).map(word => FormatterService.typeCase(word)).join(' ');
    }
    return undefined;
  }
}
